<header class="header">
  <div class="logo-div">
    <img
      id="kpLogo"
      class="logo"
      src="./assets/images/kplogo1277AE.svg"
      (click)="home()"
      (keydown.enter)="home()"
      alt="Kaiser Permanente Logo - Developer Portal"
      role="img"
      aria-label="Kaiser Permanente Developer Portal - Return to home" />
    <p class="site-text">Developer Portal</p>
  </div>
  <div class="button-div" role="region" aria-label="User account and actions">
    <form [formGroup]="loginForm" *ngIf="authenticated === false">
      <div class="action-plus-link-div">
        <div class="action-div">
          <button mat-stroked-button class="header-login-button" (click)="login()" (keydown.enter)="login()">
            Login
          </button>
          <button
            mat-stroked-button
            class="header-signup-button"
            (click)="createAccount($event)"
            (keydown.enter)="createAccount($event)">
            Create an Account
          </button>
        </div>
        <p class="header-text">
          By using this website you agree to our
          <span
            class="header-link-text"
            role="link"
            tabindex="0"
            (keydown.enter)="onTermsAndConditions($event)"
            (click)="onTermsAndConditions($event)"
            aria-label="Terms and Conditions">
            Terms and Conditions
          </span>
          <br />
        </p>
      </div>
    </form>
    <div class="action-div" *ngIf="authenticated">
      <img class="logo" src="./assets/images/icons/profile_circle_icon.svg" alt="User Profile" />
      <div class="button-menu-div">
        <button mat-button [matMenuTriggerFor]="menu" aria-labelledby="userDisplayName">
          <span id="userDisplayName">{{ displayName }}</span>
          <mat-icon aria-hidden="true">keyboard_arrow_down</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="editProfile()" (keydown.enter)="editProfile()">Edit Profile</button>
          <button mat-menu-item (click)="personaSetup()" (keydown.enter)="personaSetup()">Persona Setup</button>
          <button mat-menu-item (click)="logout()" (keydown.enter)="logout()">Logout</button>
        </mat-menu>
      </div>
    </div>
  </div>
</header>
<kp-global-banner></kp-global-banner>
<nav class="navbar-div" *ngIf="showNavBar" role="navigation" aria-label="Main navigation">
  <kp-navbar style="width: 100%"></kp-navbar>
</nav>
<div class="page-header-div" *ngIf="showPageHeader" role="region" aria-label="Page header">
  <h2 class="page-header-label">
    <img src="{{ pageHeaderImage }}" [attr.alt]="pageHeaderLabel + ' icon'" class="page-header-icon" aria-hidden="true" />
    <span> {{ pageHeaderLabel }}</span>
  </h2>
  <button
    *ngIf="authenticated === false"
    class="primary-action-button"
    style="white-space: nowrap !important"
    (click)="createAccount($event)"
    aria-label="Create an Account">
    Create an Account
  </button>
</div>
